import styled, { css } from 'styled-components';

export const InsightIconsWrapper = styled.div<{ $disabled: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;

  ${({ $disabled }) =>
    !$disabled &&
    css`
      &:hover {
        transform: scale(1.25);
      }
    `}
`;

export const StyledImg = styled.img<{ width: number; height: number }>`
  position: absolute;
  right: 0;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;
